export const AppRoute = {
  ROOT: `/`,
  CONTACTS: `/contacts`,
};

export const PHOTOS = ['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg', '7.jpg', '8.jpg', '9.jpg', '10.jpg'];

export const defaultFormData = {
  name: '',
  phone: '',
  email: '',
  avatar: 'placeholder.svg'
};
